import { getHttpClient } from '../api/axiosInstance'
import { useQuery } from '@tanstack/react-query'
import indexOf from 'lodash/indexOf'

const jwtDecode = require('jwt-decode')

const key = 'userSession'

const getInfomation = async () => {
  const apiClient = getHttpClient()

  const response = await apiClient.get('/common/information/')
  return response.data
}

const useUserSession = () => {
  return useQuery({
    queryKey: [key],
    queryFn: () => getInfomation(),
    refetchOnWindowFocus: false,
    refetchInterval: 1000 * 60 * 60 //  1 hora en ms
  })
};

export { useUserSession }

export const CLIENT_MANAGER = ['ROLE_MANAGER_ADMIN', 'ROLE_MANAGER_CLIENT'] // ROLE_TYPE_MANAGER
export const VENDOR_MANAGER = ['ROLE_MANAGER_ADMIN', 'ROLE_MANAGER_VENDOR'] // ROLE_TYPE_MANAGER
export const FINANCE_MANAGER = ['ROLE_MANAGER_ADMIN', 'ROLE_MANAGER_FINANCE'] // ROLE_TYPE_MANAGER
export const PROJECT_MANAGER = ['ROLE_MANAGER_ADMIN', 'ROLE_MANAGER_PROJECT'] // ROLE_TYPE_MANAGER
export const ADMIN_MANAGER = ['ROLE_MANAGER_ADMIN'] // ROLE_TYPE_MANAGER

export const getUserRoles = (session) => {
  const token = window.localStorage.getItem('access-token')
  const decoded = jwtDecode(token)

  return decoded?.roles || []
};

export const isUserOwner = (state) => {
  const user = getUserSession(state)

  return user === 'admin'
};

export const getUserSession = (session) => {
  return session.user.username || false
};

/**
 * Función que cheque si un usuario tiene el un role dado
 */
export const isGranted = (role, roles) => {
  return indexOf(roles, role) >= 0
};

/**
 * Función que cheque si un usuario tiene al menos uno de los roles pasados como parametros
 */
export const isGrantedSome = (permisos, roles) => {
  return permisos.some((role) => indexOf(roles, role) >= 0)
};

export const isAdminManager = (roles) => isGrantedSome(ADMIN_MANAGER, roles)
export const isProjectManager = (roles) =>
  isGrantedSome(PROJECT_MANAGER, roles)
export const isFinanceManager = (roles) =>
  isGrantedSome(FINANCE_MANAGER, roles)
export const isVendorManager = (roles) => isGrantedSome(VENDOR_MANAGER, roles)
export const isClientManager = (roles) => isGrantedSome(CLIENT_MANAGER, roles)

export const isAdmin = (session) => {
  const roles = getUserRoles(session)

  return isAdminManager(roles)
};
